import {
  Ng1StateDeclaration,
  StateParams,
  StateProvider,
  StateService,
} from "@uirouter/angularjs";
import { vsComponentName as ProcessNotesModalComponentName } from "./component";
import {
  vsComponentName as formViewComponentName,
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../records/forms/formView";
import {
  ProcessApiResponse,
  ProcessInstancesNotesView,
  ProcessState,
} from "../../../model/ProcessApi";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { ServiceResponse } from "../../../../records/server/query";

export function addRoute($stateProvider: StateProvider, name: string) {
  $stateProvider.state(name, noteState()).state(`${name}.add`, noteAddState());
}

export function noteAddState(): Ng1StateDeclaration {
  return {
    component: formViewComponentName,
    url: "/add",
    resolve: {
      fields: [
        "process",
        (process: ProcessApiResponse<any>) => {
          const states = process.States.filter((s) =>
            ["InProgress", "Complete"].includes(s.StatusCategory)
          ).map((s) => ({
            value: s.Id,
            name: s.Name,
          }));

          return [
            ...fieldHelpers.columnLayout(
              [
                fieldHelpers.selectField({
                  key: "StateId",
                  required: true,
                  options: states,
                }),
              ],
              4
            ),
            ...fieldHelpers.columnLayout(
              [
                fieldHelpers.simpleStringField({
                  key: "Notes",
                  label: "Note",
                  required: true,
                }),
              ],
              1
            ),
          ];
        },
      ],
      processState: [
        "$stateParams",
        ($stateParams: StateParams) => $stateParams.processState,
      ],
      model: [
        "process",
        "processState",
        (process: ProcessApiResponse<any>, processState?: ProcessState) => ({
          StateId: process.States.find((s) => s.Id === processState?.Id)?.Id,
        }),
      ],
      title: [() => "Add Note"],
      onSubmit: [
        FormViewServiceName,
        "process",
        "$state",
        (
          formViewService: FormViewService,
          process: ProcessApiResponse<any>,
          $state: StateService
        ) => [
          "formViewController",
          "model",
          (formViewController: FormViewController, model: any) =>
            formViewService
              .submitForm<ServiceResponse<ProcessInstancesNotesView>>({
                formObject: model,
                formViewController,
                method: "POST",
                url: `/api/processes/instances/${process.Id}/notes`,
              })
              .then((r) => $state.go("^", undefined, { reload: true })),
        ],
      ],
      onCancel: ["$state", ($state: StateService) => [() => $state.go("^")]],
      showButtonsAtTop: [() => false],
    },
  };
}

export function noteState(): Ng1StateDeclaration {
  return {
    component: ProcessNotesModalComponentName,
    url: "/notes",
    params: {
      processState: undefined,
    },
    resolve: {},
  };
}
